<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-form inline class="backborder1 demo-form-inline" size="small">
        <el-form-item>
          <el-select v-model="form.idle_status" placeholder="请选择货位闲置状态" clearable>
            <el-option label="空货位" value="1"></el-option>
            <el-option label="占用货位" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.status" placeholder="请选择启用状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.keyword" placeholder="请输入搜索关键词" clearable></el-input>
          <!-- {{ JSON.stringify(currentCommand) }} -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList(currentNode)">搜索</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="$refs.StorageLocationModelRef.open()">新增货位</el-button>
          <el-button type="primary" icon="el-icon-upload" @click="openUploadDialog">导入货位</el-button>
        </el-form-item>
      </el-form>
      <div class="backborder2 storage-location-content" style="margin-top:10px">
        <div class="left">
          <el-button type="primary" icon="el-icon-plus" @click="addwarehouse" size="mini">新增仓库</el-button>
          <el-button circle icon="el-icon-refresh" size="mini" @click="getTreeData"></el-button>
          <div class="divider"></div>
          <!-- <div>{{ this.record.map(item => item.id) }}</div> -->
          <el-scrollbar class="tree-container">
            <el-tree :data="treeData" accordion :props="defaultProps" node-key="id" :default-expand-all="false"
              :default-expanded-keys="['all', ...this.record.map(item => item.id)]" :expand-on-click-node="false"
              @node-click="handleNodeClick" @node-expand="handleExpand" @node-collapse="handleCollapse">
              <span class="custom-tree-node" slot-scope="{ node, data }"
                :class="{ treeActive: showId == `${data.type}-${data.id}` }">
                <span class="labelname" v-if="data.type == 0">{{ node.label }}</span>
                <span class="labelname" v-if="data.type > 0">{{ getNameBytype(data.type) }}{{ node.label }}</span>
                <span v-if="data.type < 5 && showId == `${data.type}-${data.id}` && data.id != 'all'">
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      <i class="el-icon-setting" style="margin-left: 10px;"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="data.type < 4" :command="{ action: 'add', data: data }">新增{{
                        getNameBytype(data.type + 1) }}</el-dropdown-item>
                      <el-dropdown-item v-if="data.type > 0"
                        :command="{ action: 'edit', data: data }">编辑</el-dropdown-item>
                      <el-dropdown-item v-if="data.type > 0"
                        :command="{ action: 'delete', data: data }">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
        <div class="right">
          <el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange"
            v-loading="tableLoading" border>
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="full_code" label="货位">
            </el-table-column>
            <el-table-column prop="warehouse_name" label="所属仓库">
            </el-table-column>
            <el-table-column prop="numbers" label="商品数量">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="180">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="1"
                  :inactive-value="0" @change="handleStatusChange(scope.row)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                <el-button size="mini" @click="handlePrintBarcode(scope.row)">打印条码</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="table-footer">
            <div class="left-actions">
              <el-button size="mini" type="danger" :disabled="this.multipleSelection.length == 0"
                @click="handleBatchDelete">批量删除</el-button>
              <el-button size="mini" :disabled="this.multipleSelection.length == 0"
                @click="handleBatchPrintBarcode">批量打印条码</el-button>
            </div>
            <div class="right-pagination">
              <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
                :page-size="form.limit" :current-page="form.page" @size-change="handleSizeChange"
                @current-change="handlePageChange" />
            </div>
          </div>
        </div>
      </div>
      <StorageLocationModel ref="StorageLocationModelRef" :treeData="addModelData" @success="getList(currentCommand)" />
      <StorageLocationPrintModel ref="StorageLocationPrintModelRef" :printData="multipleSelection" />

      <!-- 新增弹窗 -->
      <el-dialog :title="`${this.currentCommand.action == 'edit' ? '编辑' : '新增'}${addNameByTitle}`"
        :visible.sync="createDialog" width="30%" @closed="addForm.code = ''">
        <el-form :model="addForm" label-width="80px">
          <el-form-item v-if="addNameByTitle != '库区'" label="名称">
            <el-input v-model="addForm.code" :placeholder="`请输入${addNameByTitle}名称`" clearable></el-input>
          </el-form-item>
          <el-form-item v-if="addNameByTitle == '库区'" label="名称">
            <el-select v-model="addForm.code" placeholder="请选择库区名称" clearable style="width: 100%;">
              <el-option v-for="item in names" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="addNameByTitle == '货位'" label="破损货位">
            <el-checkbox v-model="addForm.is_damaged" :true-label="1" :false-label="0"></el-checkbox>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="createDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd" :loading="submitLoading">保 存</el-button>
        </span>
      </el-dialog>

      <!-- 导入数据弹窗 -->
      <el-dialog title="导入货位" :visible.sync="dialogVisible" width="60%" :before-close="handleClose"
        @closed="uploadList = []">
        <div class="dialog-content">
          <div class="left-column">
            <el-button type="primary" size="mini" @click="getdownmoremodel">点击下载模板</el-button>
            <el-button type="primary" size="mini" @click="uploadinfos" :loading="uploadgoodsLoading">上传模板</el-button>
            <el-checkbox v-model="auto_create" size="mini"
              style="margin-left: 20px;">库区/巷道号/货架/货层在系统中不存在时自动创建</el-checkbox>
          </div>
          <div class="right-column">
            <el-button size="mini" @click="dialogVisible = false">取消</el-button>
            <el-button size="mini" type="primary" :loading="uploadSubmitLoading" @click="handleSubmit">提交</el-button>
          </div>
        </div>
        <div style="color: red;">单次导入不超过200个货位</div>
        <el-table :data="uploadList" style="width: 100%; margin-top: 20px;" size="mini"
          @selection-change="handleSelectionChange" v-loading="tableLoading" border>
          <el-table-column prop="warehouse_name" label="仓库"></el-table-column>
          <el-table-column prop="area" label="库区"></el-table-column>
          <el-table-column prop="aisle" label="巷道号"></el-table-column>
          <el-table-column prop="shelf" label="货架"></el-table-column>
          <el-table-column prop="layer" label="货层"></el-table-column>
          <el-table-column prop="location" label="货位"></el-table-column>
        </el-table>
        <!-- slot=footer -->
        <div class="table-upload-footer">
          <el-button size="mini" @click="dialogVisible = false">取消</el-button>
          <el-button size="mini" type="primary" :loading="uploadSubmitLoading" @click="handleSubmit">提交</el-button>
        </div>
      </el-dialog>
      <input id="fileupload" type="file" @change="importFile"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style="display:none" title="1" />
    </div>
  </transition>
</template>

<script>
import StorageLocationModel from './StorageLocationModel.vue';
import StorageLocationPrintModel from './StorageLocationPrintModel.vue';
export default {
  components: {
    StorageLocationModel, StorageLocationPrintModel
  },
  data() {
    return {
      record: [],
      dialogVisible: false,
      uploadgoodsLoading: false,
      uploadSubmitLoading: false,
      uploadList: [],
      auto_create: true,
      loading: false,
      createDialog: false,
      addNameByTitle: '',
      currentCommand: {},
      submitLoading: false,
      showId: '',
      tableLoading: false,
      form: {
        warehouse_id: '',
        layer_id: '',
        keyword: '',
        status: '',
        idle_status: '',
        limit: 10,
        page: 1
      },
      addForm: {
        code: '',
        is_damaged: 0
      },
      warehouseId: '',
      treeData: [],
      addModelData: [],
      defaultProps: {
        children: 'children',
        label: 'code'
      },
      tableData: [],
      multipleSelection: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      names: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      currentNode: null
    }
  },
  created() {
    this.getTreeData()
    this.getList()
  },
  methods: {
    /** 导入文件 **/
    uploadinfos() {
      document.getElementById("fileupload").click();
    },
    openUploadDialog() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      done();
    },
    handleSubmit() {
      // 处理提交逻辑
      this.uploadSubmitLoading = true
      this.$axios({
        url: this.GLOBAL.domain + 'StorageLocation/import_confirm',
        method: 'POST',
        data: {
          json_str: JSON.stringify(this.uploadList),
          auto_create: this.auto_create ? 1 : 0 // 开关 1-开 0-关 库区/巷道号/货架/货层在系统中不存在时自动创建
        }
      })
        .then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: '导入成功'
            })
            this.getList()
          }
        })
        .finally(() => {
          this.uploadSubmitLoading = false
        })
      this.dialogVisible = false;
    },
    //下载批量导入数据模板
    getdownmoremodel() {
      location.href = this.GLOBAL.domain + "StorageLocation/download_template?token=" + this.$cookies.get("token");
    },
    getList(node) {
      if (node) {
        this.currentNode = node
        this.form.warehouse_id = node.warehouse_id
        this.form.layer_id = node.type != 0 ? node.id : ''
      }
      this.tableLoading = true
      this.$axios({
        url: this.GLOBAL.domain + 'StorageLocation/lists',
        method: 'POST',
        data: this.form
      })
        .then(res => {
          if (res) {
            this.tableData = res.Data
            this.total = res.count.counts || 0
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    showSetting(data) {
      this.showId = data.id
    },
    hideSetting() {
      this.showId = ''
    },
    // 获取货位树节点数据
    getTreeData() {
      this.$axios({
        url: this.GLOBAL.domain + 'StorageLocation/tree',
        method: 'POST',
        data: {
          warehouse_id: this.warehouseId
        }
      }).then(res => {
        if (res) {
          this.addModelData = res.Data
          this.treeData = [
            {
              id: 'all',
              code: '全部',
              type: 0,
              children: res.Data.map(item => {
                return {
                  ...item,
                  code: item.name
                }
              })
            }
          ]
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 根据type获取仓库类型名称
    getNameBytype(type) {
      // 类型: 1-库区 2-巷道 3-货架 4-货层 5-货位 0表示仓库
      switch (type) {
        case 1:
          return '库区'
        case 2:
          return '巷道'
        case 3:
          return '货架'
        case 4:
          return '货层'
        case 5:
          return '货位'
      }
    },
    addwarehouse() {
      this.$emit('listenchild', { name: '新增仓库', url: 'Warehouseadd' });
    },
    openRecord(node) {
      // node 格式 = {id：1， type:1}
      // type的类型有： 0仓库 1库区 2巷道 3货架 4货层
      // 先查询this.record数组中是否有这个id的对象属性和type属性
      // 如果没有相同id，没有相同type，则直接添加
      // 如果没有相同id，有相同type，则删除type=node.type相同的数据，以及删除其它type大于当前node.type的数据,然后把node添加进去
      // 有相同id，则直接删除this.record数组中id=node.id的数据，并且node不再添加进去

      const index = this.record.findIndex(item => item.id === node.id);

      if (index === -1) {
        // 如果没有相同id，则检查是否有相同的type
        const typeIndex = this.record.findIndex(item => item.type === node.type);
        if (typeIndex !== -1) {
          // 删除type=node.type相同的数据，以及删除其它type大于当前node.type的数据
          this.record = this.record.filter(item => item.type < node.type);
        }
        // 直接添加node
        this.record.push(node);
      } else {
        // 有相同id，则直接删除this.record数组中id=node.id的数据，并且node不再添加进去
        this.record.splice(index, 1);
      }
    },
    handleExpand(node) {
      this.record.push({
        id: node.id,
        type: node.type
      })
    },
    handleCollapse(node) {
      // 关闭的时候，把type大于node.type的也删除
      this.record = this.record.filter(item => item.type < node.type)
    },
    handleNodeClick(node) {
      const data = JSON.parse(JSON.stringify(node))
      this.showId = `${data.type}-${data.id}`
      // 这里可以添加节点点击的逻辑
      if (data.type == 0) {
        // 仓库
        data.warehouse_id = data.id
      }
      this.currentCommand = data
      this.getList(data)
      this.form.page = 1
      // 清除掉所有activeParent的类名
      document.querySelectorAll('.el-tree-node__content').forEach(item => {
        item.classList.remove('activeParent')
      })

      // 在数据更新后，找到树形控件下的active类名
      this.$nextTick(() => {
        const activeNode = document.getElementsByClassName('treeActive')[0]
        // 通过activeNode找到它的父节点
        if (activeNode && activeNode.parentNode) {
          // 找到activeNode的父节点下的所有li标签
          // 给activeNode.parentNode添加一个类名：activeParent
          activeNode.parentNode.classList.add('activeParent')
        }

      })
    },
    handleCommand(command) {
      this.currentCommand = command;
      switch (command.action) {
        case 'add':
          this.addTreeByType(command)
          break
        case 'edit':
          // TODO: 实现编辑逻辑
          this.editTreeByType(command)
          break
        case 'delete':
          // TODO: 实现删除逻辑
          this.handleDelete(command.data)
          break
        default:
          break
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleEdit(row) {
      console.log(row, 'PPPPPPPPPPPP')
      // 这里可以添加编辑逻辑
      this.editTreeByType({
        data: row,
        action: 'edit'
      })
    },
    handleDelete(row) {
      this.$confirm(`此操作将永久删除【${this.getNameBytype(row.type)}${row.code}】, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteTree({
          ids: row.id,
          warehouse_id: row.warehouse_id
        })
      })

      // 这里可以添加删除逻辑
    },
    handlePrintBarcode(row) {
      this.$refs.StorageLocationPrintModelRef.open([row])
    },
    handleStatusChange(row) {
      this.$axios({
        url: this.GLOBAL.domain + 'StorageLocation/save_location',
        method: 'POST',
        data: {
          ...row
        }
      }).then(res => {
        this.$message.success(`修改成功`);
      })
        .finally(() => {
          this.getList()
        })
    },
    handleBatchDelete() {
      this.$confirm(`此操作将永久删除已选货位, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteTree({
          ids: this.multipleSelection.map(item => item.id).join(','),
          warehouse_id: this.multipleSelection[0].warehouse_id
        })
      })
      // 这里可以添加批量删除逻辑
    },
    handleBatchPrintBarcode() {
      this.$refs.StorageLocationPrintModelRef.open(this.multipleSelection)
      // 这里可以添加批量打印条码逻辑
    },
    handleSizeChange(size) {
      this.form.limit = size
      this.form.page = 1
      this.getList()
    },
    handlePageChange(page) {
      this.form.page = page
      this.getList()
    },
    submitAdd() {
      if (!this.addForm.code) {
        this.$message.error(`请输入${this.addNameByTitle}名称`)
        return
      }
      const command = this.currentCommand;
      let data;
      if (command.action == 'edit') {
        // 编辑
        data = {
          warehouse_id: command.data.warehouse_id,
          type: command.data.type,
          code: this.addForm.code,
          pid: command.data.pid,
          id: command.data.id,
          is_damaged: this.addForm.is_damaged
        }
      } else {
        // 新增
        data = {
          warehouse_id: command.data.type == 0 ? command.data.id : command.data.warehouse_id,
          type: command.data.type + 1,
          code: this.addForm.code,
          pid: command.data.type == 0 ? 0 : command.data.id,
          is_damaged: this.addForm.is_damaged
        }
      }
      // return
      this.submitLoading = true
      this.$axios({
        url: this.GLOBAL.domain + 'StorageLocation/save_location',
        method: 'POST',
        data
      }).then(res => {
        if (res) {
          this.$message.success(`操作${this.addNameByTitle}成功`);
          this.getTreeData();
          this.getList()
          this.createDialog = false;
          this.addForm.code = ''
          this.addForm.is_damaged = 0
        }
      })
        .finally(() => {
          this.submitLoading = false

        })

    },
    addTreeByType(command) {
      const type = command.data.type + 1;
      this.addNameByTitle = this.getNameBytype(type)
      this.createDialog = true
    },
    editTreeByType(command) {
      this.addNameByTitle = this.getNameBytype(command.data.type)
      this.addForm.code = command.data.code
      this.addForm.is_damaged = command.data.is_damaged
      this.currentCommand = command
      this.createDialog = true
    },
    deleteTree({ ids, warehouse_id }) {
      this.$axios({
        url: this.GLOBAL.domain + 'StorageLocation/del',
        method: 'POST',
        data: {
          warehouse_id: warehouse_id,
          ids: ids
        }
      })
        .then(res => {
          if (res) {
            this.$message.success('删除成功！')
            this.getTreeData()
            this.getList(this.currentCommand.data || this.currentCommand)
          }
        })
    },
    /************** 导入excel表格数据 **************/
    /************** 导入excel表格数据 **************/
    importFile(event) {
      // 通过DOM取文件数据
      var file = event.target.files[0];

      if (!file) return;

      const formData = new FormData();
      formData.append('excel', file);
      formData.append('token', this.$cookies.get('token'));

      // 清空输入框的文件值，避免下次change事件失效
      document.getElementById('fileupload').value = null;
      this.uploadgoodsLoading = true;

      var resource = this.$resource(this.GLOBAL.domain + 'StorageLocation/import_preview');
      resource.save(formData).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          if (res.data.Result == 12) {
            this.$message.error(res.data.Message);
          }
          this.uploadgoodsLoading = false;
        } else {
          this.uploadList = JSON.parse(Base64.decode(res.data.Data));
        }
      }).finally(() => {
        this.uploadgoodsLoading = false;
      })
    }
  }
}
</script>

<style scoped>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%;
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%;
}

.tree-container>>>.activeParent {
  background-color: #d9d8d8 !important;
}

.storage-location-content {
  display: flex;
  padding: 20px;
}

.storage-location-content .left {
  height: calc(100vh - 275px);
  flex-shrink: 0;
  width: 240px;
  border: 1px solid #eeeeee;
  padding: 10px;
}

.left>>>.el-scrollbar__wrap {
  overflow-x: hidden;
}

.tree-container {
  height: calc(100% - 50px);
  overflow-x: hidden;
}

.storage-location-content .right {
  margin-left: 30px;
  width: calc(100% - 292px);
}

.divider {
  margin: 10px 0;
  border-bottom: 1px solid #ddd;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 20px;
  width: calc(100% - 40px);
}

.custom-tree-node .labelname {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.left-actions .el-button {
  margin-right: 10px;
}

.right-pagination {
  text-align: right;
}

.dialog-content {
  display: flex;
  justify-content: space-between;
}

.left-column {
  display: flex;
}

.right-column {
  display: flex;
}

.table-upload-footer {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/inventory/StorageLocation.vue